<template>
    <div v-if="resourceList && resourceList.length > 0">
        <hr>
        <div id="slide-resource-gallery">
            <div v-for="resource in resourceList" :key="resource.id">
                <div 
                    class="slide-resource slide-image" 
                    v-if="['Image'].includes(resource.type)"
                    :style="'background-image:url('+resource.res_url+')'" 
                >
                    <md-tooltip md-direction="top" v-if="resource.name">
                        {{resource.name}}
                    </md-tooltip>
                </div>
                <div 
                    class="slide-resource slide-video htmlvid" 
                    v-if="['Video'].includes(resource.type)"
                    :vidSrc="resource.res_url"
                >
                    Video File
                    <md-tooltip md-direction="top" v-if="resource.name">
                        {{resource.name}}
                    </md-tooltip>
                </div>
                <div 
                    class="slide-resource slide-video youtube" 
                    v-if="resource.type == 'Youtube'" 
                    :style="'background-image:url(https://i.ytimg.com/vi/' + resource.res_id + '/mqdefault.jpg)'" 
                    :ytSrc="resource.res_id"
                >
                    <md-tooltip md-direction="top" v-if="resource.name">
                        {{resource.name}}
                    </md-tooltip>
                </div>
                <div 
                    class="slide-resource slide-video vimeo" 
                    v-if="resource.type == 'Vimeo'" 
                    :vimeoSrc="resource.res_id"
                >
                    Vimeo
                    <md-tooltip md-direction="top" v-if="resource.name">
                        {{resource.name}}
                    </md-tooltip>
                </div>
                <a 
                    class="slide-resource officefile" 
                    v-if="resource.type == 'Office File'" 
                    :href="resource.res_url"
                    target="_blank"
                >
                    <span>Office File</span>
                    <md-tooltip md-direction="top">
                        {{resource.name}}
                    </md-tooltip>
                </a>
            </div>
        </div>
    </div>
</template>

<script>
    var BigPicture = require('bigpicture')

    function setClickHandler(selector, fn) {
        var elemList = document.querySelectorAll(selector)
        for (var i = 0; i < elemList.length; i++) {
            elemList[i].addEventListener('click', fn)
        }
    }
    export default {
        props: {
            resourceList: {
                type: Array
            },
        },
        components: {
        },
        data: function () {
            return {}
        },
        methods: {},
        mounted: function () {
            this.$nextTick(function () {
                var imageLinks = document.querySelectorAll('.slide-image')
                for (var i = 0; i < imageLinks.length; i++) {
                    imageLinks[i].addEventListener('click', function (e) {
                        e.preventDefault()
                        BigPicture({
                            el: e.target,
                        })
                    })
                }
                //Videos
                setClickHandler('.slide-video', function (e) {
                    var className = e.target.className;
                    ~className.indexOf('htmlvid') &&
                        BigPicture({
                            el: e.target,
                            vidSrc: e.target.getAttribute('vidSrc')
                        });
                    ~className.indexOf('vimeo') &&
                        BigPicture({
                            el: e.target,
                            vimeoSrc: e.target.getAttribute('vimeoSrc')
                        });
                    ~className.indexOf('youtube') &&
                        BigPicture({
                            el: e.target,
                            ytSrc: e.target.getAttribute('ytSrc')
                        });
                });
            })
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    a{
        color: inherit !important;
    }
    #slide-resource-gallery {
        display: flex;
        overflow-x: scroll;
        align-items: center;
    }

    .slide-resource {
        margin: 10px;
        border: 1px solid #555;
        width: 200px;
        height: 200px;
        background-size: cover;
        position: relative;
        display: flex;
        justify-content:center;
        align-content:center;
        flex-direction:column; 
        padding: 20px;
    }

    .slide-resource:after,
    .slide-resource:before {
        content: '';
        left: 0;
        top: 0;
        right: 0;
        bottom: 0
    }

    .slide-resource:after,
    .slide-resource:before {
        position: absolute;
        transition: opacity .2s;
        content: ''
    }

    .slide-resource:after {
        background-repeat: no-repeat;
        background-position: .7em .7em;
        opacity: .5;
        background-size: 2em
    }

    .slide-resource:not(.slide-add):before {
        background-color: black;
        opacity: .1
    }

    .slide-resource:hover:after {
        opacity: .8
    }

    .slide-resource:hover:before {
        opacity: 0
    }

    .vimeo:after {
        background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20150%20150%22%3E%3Cpath%20d%3D%22M150%20135c0%208.28-6.72%2015-15%2015H15c-8.28%200-15-6.72-15-15V15C0%206.72%206.72%200%2015%200h120c8.28%200%2015%206.72%2015%2015v120%22%20fill%3D%22%2353bded%22%2F%3E%3Cpath%20d%3D%22M126.22%2049.8c-.5%2010.56-7.85%2025-22.1%2043.35-14.75%2019.15-27.22%2028.72-37.42%2028.72-6.32%200-11.66-5.82-16.03-17.5L41.92%2072.3c-3.24-11.66-6.72-17.5-10.44-17.5-.82%200-3.65%201.7-8.5%205.1l-5.1-6.56c5.34-4.7%2010.62-9.4%2015.8-14.1%207.14-6.17%2012.5-9.4%2016.07-9.74%208.44-.8%2013.63%204.96%2015.58%2017.3%202.1%2013.32%203.56%2021.6%204.38%2024.84%202.45%2011.05%205.13%2016.57%208.05%2016.57%202.27%200%205.68-3.57%2010.22-10.74%204.54-7.16%206.97-12.6%207.3-16.36.65-6.2-1.78-9.3-7.3-9.3-2.6%200-5.27.6-8.02%201.78%205.33-17.45%2015.5-25.92%2030.53-25.44%2011.14.33%2016.4%207.55%2015.75%2021.67%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E')
    }

    .htmlvid:after {
        background-image: url('data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAxdjIyaDI0di0yMmgtMjR6bTQgMjBoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0xNCAxMmgtMTJ2LTEwaDEydjEwem00IDRoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0wLTRoLTJ2LTJoMnYyem0tMTIgMTB2LTZsNSAzLTUgM3oiLz48L3N2Zz4=')
    }

    .youtube:after {
        background-image: url('data:image/svg+xml;charset=utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%20159.00691%20111.60904%22%3E%3Cpath%20d%3D%22M36.2%20111c-25-1.3-29.6-4-34-18.6C.3%2086.7%200%2080%200%2057.4%200%2019%202.3%209.7%2013.6%204c11.5-5.6%20120-5.6%20131.4%200%206%203%2010%208.7%2011.8%2017.2%202%209.8%203%2042.2%201.5%2057.5-2%2020.4-7%2028.5-19.2%2030.8-7.6%201.5-82%202.4-102.8%201.3zM85%2065.3c11.3-6%2020.4-11%2020.3-11L84%2043%2063%2032v22c0%2012%20.4%2022%20.8%2022%20.3%200%2010-5%2021.2-10.8z%22%20fill%3D%22%23db2823%22%2F%3E%3Cpath%20d%3D%22M63.2%2032c-.4.3-.2%201-.3%201.3v28.5c0%204.6%200%209.2.5%2013.8%200%20.4.3.7.6.5%206.3-3%2012.3-6%2018.4-9.3%207.5-4%2015-7.8%2022.2-12%20.3%200%201-.4.6-.8-12.8-7-25.7-13.5-38.6-20.2-1-.6-2.2-1.3-3.4-1.7z%22%20fill%3D%22%23fff%22%2F%3E%3C%2Fsvg%3E');
        background-size: 2.5em
    }

    .officefile:after {
        background-image: url('data:image/png;base64,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');
    }
</style>